import React, { useState } from 'react';

const ContactForm = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', services: [], message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const onServicesChange = (e) => {
    const options = Array.from(e.target.selectedOptions).map((o) => o.value);
    setForm((f) => ({ ...f, services: options }));
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    const apiUrl = process.env.REACT_APP_CONTACT_API_URL;

    // If API not configured, fallback to mailto
    if (!apiUrl) {
      const subject = encodeURIComponent('Free Quote Request – Lawns Out West');
      const body = encodeURIComponent(
        `Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\nServices: ${form.services.join(', ')}\n\nMessage:\n${form.message}`
      );
      window.location.href = `mailto:lawnsoutwest@outlook.com?subject=${subject}&body=${body}`;
      return;
    }

    try {
      setSubmitting(true);
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Request failed');
      setStatus('ok');
      setForm({ name: '', email: '', phone: '', services: [], message: '' });
    } catch (err) {
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <form className="contact-form" onSubmit={onSubmit}>
      <div className="row">
        <input name="name" placeholder="Name" value={form.name} onChange={onChange} required />
        <input type="email" name="email" placeholder="Email" value={form.email} onChange={onChange} required />
      </div>
      <div className="row">
        <input name="phone" placeholder="Phone" value={form.phone} onChange={onChange} required />
        <select name="services" multiple value={form.services} onChange={onServicesChange} required>
          <option disabled value="">Service(s) Interested In</option>
          <option>Regular Mowing</option>
          <option>Edging</option>
          <option>Weeding & Weed Control</option>
          <option>Hedging & Pruning</option>
          <option>Small Tree Lopping</option>
          <option>Lawn Repair</option>
          <option>Green Waste Disposal</option>
          <option>Rubbish Removal</option>
          <option>Gutter Cleaning (Single Story)</option>
          <option>Pressure Cleaning (Driveways & Pathways)</option>
          <option>Commercial & Domestic</option>
          <option>Other</option>
        </select>
      </div>
      <div style={{ marginTop: '0.5rem' }}>
        <textarea name="message" placeholder="Message" value={form.message} onChange={onChange} />
      </div>
      <div style={{ marginTop: '0.6rem' }}>
        <button className="btn" type="submit" disabled={submitting}>
          {submitting ? 'Sending…' : 'Get My Quote'}
        </button>
      </div>
      {status === 'ok' && (
        <div className="muted" style={{ marginTop: '0.5rem', color: 'green' }}>
          Thanks! We have received your request.
        </div>
      )}
      {status === 'error' && (
        <div className="muted" style={{ marginTop: '0.5rem', color: 'crimson' }}>
          Sorry, something went wrong. Please try again or call 0423 358 158.
        </div>
      )}
    </form>
  );
};

export default ContactForm;


